// 线性计划重排后重建前序交接，避免“先执行 B，却仍依赖未来的 A”。服务端仍会重新校验。
export function moveProjectStep(steps, index, delta) {
  const next = steps.map(step => ({ ...step, dependsOn: [...(step.dependsOn || [])] }))
  const target = index + delta
  if (target < 0 || target >= next.length) return next
  const [step] = next.splice(index, 1); next.splice(target, 0, step)
  return next.map((item, i) => ({ ...item, dependsOn: i ? [next[i - 1].stepId] : [] }))
}
export const projectPlanCanEdit = status => ['waiting_plan', 'queued', 'paused_plan'].includes(status)
export const projectPlanEditMode = status => projectPlanCanEdit(status) ? 'revise' : ['running', 'waiting_input', 'waiting_approval'].includes(status) ? 'propose' : null
export const projectStepLocked = (states, stepId) => Boolean(states?.[stepId] && states[stepId].status !== 'pending')
